import React from 'react';

interface CardProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  noPadding?: boolean;
  title?: React.ReactNode;
  actions?: React.ReactNode;
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className = '', children, noPadding = false, title, actions, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={`bg-white rounded-xl border border-slate-200 shadow-soft overflow-hidden ${className}`}
        {...props}
      >
        {(title || actions) && (
          <div className="px-6 py-4 border-b border-slate-100 flex items-center justify-between">
            {title && <div className="text-lg font-semibold text-slate-800">{title}</div>}
            {actions && <div>{actions}</div>}
          </div>
        )}
        <div className={noPadding ? '' : 'p-6'}>{children}</div>
      </div>
    );
  }
);

Card.displayName = 'Card';
